import { ModelUSMeasureShowJSON, ViewerIncomingApi, ViewerOutgoingApi } from '../ebit-viewer-api';
import { ChildWindow, SendMessageOptions } from '../../embedding/child.service';
import { ScreamingSnakeCase } from '../../../utils/types';

type ZefiroOutgoingApi = ViewerOutgoingApi & {
    usMeasureShow: ModelUSMeasureShowJSON;
};

export type ZefiroOutgoingMessage = {
    [K in keyof ZefiroOutgoingApi]: { command: ScreamingSnakeCase<K>; payload: ZefiroOutgoingApi[K] };
}[keyof ZefiroOutgoingApi];

export type ZefiroIncomingMessage = {
    [K in keyof ViewerIncomingApi]: {
        command: ScreamingSnakeCase<K>;
        payload: ViewerIncomingApi[K] extends (payload: infer P, replyCommand: string, requestId: string) => unknown
            ? { payload: P; replyCommand: string; requestId: string }
            : ViewerIncomingApi[K];
    };
}[keyof ViewerIncomingApi] | { command: 'READY' };

export function postMessageToWebViewer(
    window: ChildWindow,
    message: ZefiroOutgoingMessage,
    options?: SendMessageOptions,
) {
    window.send(message, options);
}
